import { Injectable } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { CHECKOUT_CART_WEB_GET } from "src/app/constant/urls";

@Injectable()
export class HeaderService {
  constructor(private http: HttpService) {}

  getCartDetails(restaurantId: string) {
    return this.http.get(CHECKOUT_CART_WEB_GET(restaurantId)).toPromise();
  }
}
